export default __webpack_public_path__ + "static/media/Sample PDF.ba400b2b.pdf";